import { EVENT_CATEGORIES, EVENT_TYPES } from '../constants';
import type { IInitialEvent } from '../types';

// Полная сделка МФО

const EVENT_CATEGORY = EVENT_CATEGORIES.CREDITS;
const EVENT_TYPE = EVENT_TYPES.MAIN_EVENT;

export interface IMfoOfferParams {
  mfoName?: string;
  amount?: string;
  term?: string;
  rate?: string;
  snils?: string;
  fillType?: string;
}

export const eventShowFullDealBlock = ({ mfoName, amount, term, rate }: IMfoOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Показ блока полной сделки МФО',
  eventLabel: `${mfoName} | ${amount} | ${term} | ${rate}`,
  eventValue: undefined,
});

export const eventApplyForLoan = ({ mfoName, amount, term, rate }: IMfoOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Оформить займ',
  eventLabel: `${mfoName} | ${amount} | ${term} | ${rate}`,
  eventValue: undefined,
});

export const eventLoanConditions = ({ fillType, amount, term, snils }: IMfoOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Условия займа',
  eventLabel: `${fillType === 'auto' ? 'Проброс' : 'Ручное'} | ${amount} | ${term} | Снилс ${snils ? 'указан' : 'не указан'}`,
  eventValue: undefined,
});

export const eventCancelSelection = ({ amount, term, snils }: IMfoOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Отмена',
  eventLabel: `Отмена выбора | ${amount} | ${term} | Снилс ${snils ? 'указан' : 'не указан'}`,
  eventValue: undefined,
});

export const eventSubmitFullDealApplication = ({
  fillType,
  amount,
  term,
  snils,
  mfoName,
  rate,
}: IMfoOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Отправка заявки на полную сделку',
  eventLabel: `${fillType} | ${mfoName} | ${amount} | ${term} | ${rate} | Снилс ${snils ? 'указан' : 'не указан'}`,
  eventValue: undefined,
});

export const eventMyApplications = ({ mfoName, amount, term, rate }: IMfoOfferParams): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Мои заявки',
  eventLabel: `${mfoName} | ${amount} | ${term} | ${rate}`,
  eventValue: undefined,
});

export const eventButtonClick = (buttonType: string): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Нажатие на кнопку',
  eventLabel: buttonType,
  eventValue: undefined,
});

export const eventValidationError = ({
  field,
  value,
  reason,
}: {
  field: string;
  value: string;
  reason: string;
}): IInitialEvent => ({
  event: EVENT_TYPE,
  eventCategory: EVENT_CATEGORY,
  eventAction: 'Ошибка валидации',
  eventLabel: `${field} | ${value} | ${reason}`,
  eventValue: undefined,
});
